/**
 * Is used to identify consent fields within the components to set their visibilities.
 */
export enum ConsentType {
  DEALER_CONSENT = 'DEALER_CONSENT',
}
